import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PersonIcon from '@mui/icons-material/Person';
import { selectGreenCardPinnedFilters, togglePinnedFiltersState } from '@store';
import { useHasFilters } from 'hooks/common';

export const useGreenCardFilterConfig = ({ assignees }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectGreenCardPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'assignee',
        label: 'Assignee',
        icon: PersonIcon,
        options: assignees || [],
      },
    ],
    [assignees]
  );

  const currentFilters = useMemo(() => {
    return {
      assignee: router.query.assignee,
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'greenCard', pinnedFilter }));
  };

  const { hasFilters } = useHasFilters({
    pinnedFilters,
  });

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
  };
};

export default useGreenCardFilterConfig;
